export default __webpack_public_path__ + "static/media/splashscreen.3b53f2d0.png";